import React from 'react';
import Icon from '../coreUI/icon';
import Button from '../coreUI/button';
import SearchAutocomplete from '../searchAutocomplete';
import { MobileSearchBarProps } from '@src/v3/interfaces/components/mobileSearchBar';

const MobileSearchBar: React.FC<MobileSearchBarProps> = ({
  isFilterActive = false,
  onFilterClick,
  onSearchSelect,
  defaultSearchValue = [],
  searchType = '',
}) => {
  return (
    <div className="flex items-center gap-3">
      <div className="flex h-[60px] py-[var(--sds-size-space-300)] pr-6 pl-4 justify-between items-center flex-[1_0_0] rounded-[100px] border border-gray-300 bg-background-200 shadow-[-10px_-8px_20px_-3px_rgba(0,108,255,0.10),10px_10px_20px_-3px_rgba(247,31,248,0.10)]">
        <div className="flex items-center gap-2 text-gray-800 flex-1 min-w-0">
          <Icon
            iconName="searchIcon"
            iconProps={{ className: 'w-5 h-5 flex-shrink-0' }}
          />
          <div className="flex-1 min-w-0 mobile-search-bar">
            <SearchAutocomplete
              placeholder="Search for a new home"
              defaultInputValue=""
              defaultValue={defaultSearchValue}
              searchType={searchType}
              onSelect={onSearchSelect}
              extraClasses="mobile-search-input"
            />
          </div>
        </div>
        <div className="flex items-center gap-4 text-gray-1000 flex-shrink-0">
          <div className="w-px h-6 bg-gray-300"></div>
          <div className="relative">
            <Button
              variant="ghost"
              onClick={onFilterClick}
              className="p-1 hover:bg-gray-100 rounded transition-colors"
            >
              <Icon iconName="filter" iconProps={{ className: 'w-5 h-5' }} />
              {isFilterActive && (
                <div className="absolute top-0 -right-1 w-5 h-5 border-2 border-white bg-primary-dark rounded-full flex items-center justify-center z-10"></div>
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileSearchBar;
